var render = function (_h,_vm) {var _c=_vm._c;return _c('button',_vm._g(_vm._b({staticClass:"button",class:[
    _vm.data.staticClass, 
    _vm.data.class,
    _vm.props.class,
    _vm.$options.classes(_vm.props)
  ],attrs:{"type":_vm.props.type}},'button',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }